import * as XLSX from "xlsx";

export default function exportObjectivesToExcel(
  data,
  filename = "reporte_objetivos.xlsx"
) {
  // Definir los encabezados de las columnas
  const headers = [
    "No",
    "Descripcion",
    "Responsable",
    "Retraso",
    "% de Ejecucion",
    "Avance Semana Anterior",
    "Avance Semana Actual",
    "Fecha de Inicio",
    "Fecha de Fin",
    "Dias",
    "Total de Tareas",
    "Tareas Realizadas",
    "Tareas Retrasadas",
    "Cerrada Semana Anterior",
    "Cerrada Semana Actual",
    "Tareas Pendiente",
    "Tareas Semana Actual (x)",
    "Tareas Semana (X+1)",
    "Tareas Semana (X+2)",
    "Tareas Semana (X+3)",
    "Tipo de Objectivo",
    "Perspectiva"
  ];

  // Validar que data sea un array
  const dataArray = Array.isArray(data) ? data : [data];

  // Preparar los datos para la hoja de cálculo
  const worksheetData = [headers];

  // Agregar las filas de datos
  dataArray.forEach((item, index) => {
    const row = [
      item.no || item.No || index + 1,
      item.descripcion || item.Descripcion || "",
      item.responsable || item.Responsable || "",
      item.retraso || item.Retraso || "",
      item.porcentajeEjecucion || item["%deEjecucion"] || "",
      item.avanceSemanaAnterior || item.AvanceSemanaAnterior || "",
      item.avanceSemanaActual || item.AvanceSemanaActual || "",
      item.fechaInicio || item.FechadeInicio || "",
      item.fechaFin || item.FechadeFin || "",
      item.dias || item.Dias || "",
      item.totalTareas || item.TotaldeTareas || "",
      item.tareasRealizadas || item.TareasRealizadas || "",
      item.tareasRetrasadas || item.TareasRetrasadas || "",
      item.cerradaSemanaAnterior || item.CerradaSemanaAnterior || "",
      item.cerradaSemanaActual || item.CerradaSemanaActual || "",
      item.tareasPendiente || item.TareasPendientes || "",
      item.tareasSemanaActual || item.TareasSemanaActual || "",
      item.tareasSemanaX1 || item.TareasSemanaX1 || "",
      item.tareasSemanaX2 || item.TareasSemanaX2 || "",
      item.tareasSemanaX3 || item.TareasSemanaX3 || "",
      item.tipoObjetivo || item.TipodeObjectivo || "",
      item.perspectiva || item.Perspectiva || ""
    ];
    worksheetData.push(row);
  });

  // Crear la hoja de cálculo
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Ajustar el ancho de las columnas
  const columnWidths = headers.map((header) => ({
    wch: Math.max(header.length + 2, 15)
  }));
  worksheet["!cols"] = columnWidths;

  // Crear el libro de trabajo
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Objetivos");

  // Exportar el archivo
  XLSX.writeFile(workbook, filename);
}
